import React, { useContext, useState } from 'react';
import FormDataContext from 'integrations/contexts/FormDataContext';

import { Input } from 'components/bootstrap';
import Select from 'components/common/Select';

import FormAdvancedOptions from './FormAdvancedOptions';
import INITIAL_FORMDATA from './_initialFormData';

import FormWrap from '../common/FormWrap';
import type { ErrorMessageType, HandleFieldUpdateType, HandleSubmitType } from '../common/utils/types';

interface Props {
  onSubmit: HandleSubmitType;
  onChange: HandleFieldUpdateType;
}

const StepSubscribe = ({ onSubmit, onChange }: Props) => {
  const { formData } = useContext(FormDataContext);
  const [formError, setFormError] = useState<ErrorMessageType>(null);
  const { pollingInterval } = formData;

  const availableContent = [
    { label: 'Audit Events', value: 'AUDIT_EVENTS' },
    { label: 'Item Usages', value: 'ITEM_USAGES' },
    { label: 'Sign In Attempts', value: 'SIGN_IN_ATTEMPTS' },
  ];

  const [contentTypes, setContentTypes] = useState(INITIAL_FORMDATA.availableContents.value);
  const [logTypeVal, setLogTypeVal] = useState(false);

  const handleSubmit = () => {
    if (pollingInterval.value >= 1) {
      setFormError(null);
      if (contentTypes.length === 0) {
        setLogTypeVal(true);

        return;
      }
      onSubmit();
    } else {
      setFormError({
        full_message: 'Please provide valid polling interval',
        nice_message: 'The Polling Interval must be greater than 1 minute.',
      });
    }
    formData.contentTypes.value = contentTypes;
  };

  return (
    <FormWrap
      onSubmit={handleSubmit}
      buttonContent="Proceed"
      title=""
      className="col-md-7"
      error={formError}
      description="">
      <label className="control-label" htmlFor="contentTypes">
        Content Types to Collect
      </label>

      <Select
        multi
        name="contentTypes"
        id="contentTypes"
        onChange={(selected: string) => setContentTypes(selected)}
        options={availableContent}
        value={contentTypes}
      />

      {logTypeVal && contentTypes.length === 0 && (
        <label htmlFor="contentTypes" style={{ color: 'red' }}>
          Select at least one Log Type
        </label>
      )}

      <span className="help-block">The events for the above content types will be fetched.</span>
      <Input
        id="pollingInterval"
        name="pollingInterval"
        type="number"
        value={pollingInterval.value || pollingInterval.defaultValue || ''}
        min="1"
        max="60"
        step="1"
        onChange={onChange}
        required
        help="Determines how often (in minutes) the input will check for new data from 1Password. The smallest allowable interval is 1 minute."
        label="Polling Interval Minutes"
      />
      <FormAdvancedOptions onChange={onChange} />
    </FormWrap>
  );
};

export default StepSubscribe;
